<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
        fxLayout="column" fxLayoutAlign="center center"
        fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

        <!-- TÍTULO E BOTÕES ALINHADOS -->
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
            <div class="logo" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Histórico de Ordens de Clientes
                </span>
            </div>

            <!-- BOTÕES ALINHADOS AO LADO DO TÍTULO -->
            <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px;">
                <!-- Botão Consultar Histórico -->
                <button mat-mini-fab 
                        color="accent"
                        matTooltip="Consultar Histórico"
                        (click)="openFiltro()">
                    <mat-icon>search</mat-icon>
                </button>
                
                <!-- Botão Importar Histórico -->
                <button mat-mini-fab 
                        color="accent"
                        matTooltip="Importar Histórico"
                        (click)="openCadastro()" 
                        *ngIf='user.role_id == 2 || user.role_id == 7 || user.role_id == 4'>
                    <mat-icon>cloud_upload</mat-icon>
                </button>
            </div>
        </div>

        <!-- SEARCH -->
        <div class="search-wrapper mx-32 mx-md-0" fxFlex>
            <div class="search" fxLayout="row" fxLayoutAlign="start center">                    
                <input 
                    #filter 
                    placeholder="Buscar Por Nome, CPF ou Conta"
                    [formControl]="search"
                    (keyup)="onEnter(filter.value)"
                    (keyup.enter)="onEnter(filter.value)"
                >
                <mat-icon 
                    style="cursor: pointer;" 
                    (click)="getAll()"
                >
                    search
                </mat-icon>
            </div>
        </div>                    
        <!-- / SEARCH -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" >
            <mat-card>
                <mat-card-header style="margin-bottom: 20px">
                    <mat-card-title>Histórico de Ordens</mat-card-title>
                    <mat-card-subtitle>
                        <span style="color: red">
                            Se o seu cliente está nessa lista significa que ele recebeu ordens. 
                            A atualização do sistema acontece a cada 30 minutos, pode ser que ele já tenha aprovado as ordens recebidas.
                        </span><br /><br />
                        <span>
                            Data da Última Atualização:  {{ statusOperacao?.data_hora_atualizacao | date:'dd/MM/yyyy HH:mm'}}
                        </span>
                        
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content> 
                    <form name="productForm" class="product w-100-p" fxLayout="column" fxFlex>
                        <mat-tab-group (selectedTabChange)="onLinkClick($event)">
                            <mat-tab label="Ordens">   
                                <ngx-datatable 
                                    #table 
                                    class='material' 
                                    [loadingIndicator]="loadingIndicator"
                                    [columns]="columns" 
                                    [columnMode]="'force'" 
                                    [headerHeight]="50"
                                    [footerHeight]="50"
                                    [rowHeight]="'auto'"
                                    [rowClass]="getRowClass"
                                    [limit]="params.per_page"
                                    [rows]='rows'>

                                    <ngx-datatable-column name="Hora" prop="data_hora_atualizacao" [sortable]="false" [width]='20'>
                                        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template >
                                            <span class="texto">
                                                {{row.data_hora_atualizacao | date:'dd/MM/yyyy H:mm'}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>                

                                    <ngx-datatable-column name="Cliente" prop="clientes" [sortable]="false" [width]="500">
                                        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{row.numero_xp}} - {{row.cliente_nome}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Escritório" prop="nome_fantasia" [sortable]="false" [width]='80' *ngIf="this.user.role_id != 5 ">
                                        <ng-template let-rowIndex="rowIndex" let-nome_fantasia="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{ nome_fantasia }} 
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Assessor" prop="assessor_nome" [sortable]="false" [width]='80' *ngIf="this.user.role_id != 5 ">
                                        <ng-template let-rowIndex="rowIndex" let-assessor_nome="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{ assessor_nome }}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Ativo" prop="sigla" [sortable]="false" [width]="80">
                                        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                                            <span 
                                                style="padding: 5px; border-radius: 10px;" 
                                                [className]="row.cor_hexadecimal"
                                                class="texto"
                                            >
                                                {{row.sigla}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Tipo" prop="operacao" [sortable]="false"  [width]="50">
                                        <ng-template let-rowIndex="rowIndex" let-operacao="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{operacao}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Qtd" prop="qtd" [sortable]="false" [width]="60">
                                        <ng-template let-rowIndex="rowIndex" let-qtd="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{qtd  | number : '1.0-0'}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Qtd. Exec." prop="qtd_executado" [sortable]="false" [width]="60">
                                        <ng-template let-rowIndex="rowIndex" let-qtd_executado="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{qtd_executado | number : '1.0-0'}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Preço" prop="preco" [sortable]="false" [width]="80">
                                        <ng-template let-rowIndex="rowIndex" let-preco="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{preco | number : '1.2-2'}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Preço Exec." prop="preco_executado" [sortable]="false"  [width]="80">
                                        <ng-template let-rowIndex="rowIndex" let-preco_executado="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{preco_executado | number : '1.2-2'}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                    <ngx-datatable-column name="Status" prop="status" [sortable]="false" [width]="90">
                                        <ng-template let-rowIndex="rowIndex" let-status="value" ngx-datatable-cell-template>
                                            <span class="texto">
                                                {{status}}
                                            </span>
                                        </ng-template>
                                    </ngx-datatable-column>

                                </ngx-datatable>
                                <div style="padding: 5px 10px">
                                    <mat-paginator 
                                        #paginator 
                                        [length]="length"
                                        [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="pageEvent($event)">
                                    </mat-paginator>
                                </div>
                            </mat-tab>

                            <mat-tab label="Ordens Não Enviadas" *ngIf="user.role_id == 2 || user.role_id == 4 || user.role_id == 7 ">
                                <app-lista-clientes-sem-ordem></app-lista-clientes-sem-ordem>
                            </mat-tab>

                            <mat-tab label="Inconsistências de Clientes" *ngIf="user.role_id == 2 || user.role_id == 4 || user.role_id == 7 ">
                                <app-lista-iconsistencia-cliente></app-lista-iconsistencia-cliente>
                            </mat-tab>

                        </mat-tab-group>
                    </form>                    
                </mat-card-content>
            </mat-card>           
        </div>
    </div>
</div>